// ======================================================================
// File Name       : LearningHistoryCSVForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Button } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../../constants/index';
import { PROGRESS_STATUS_CSV_TYPE, SELECTED_COMPLETION_TYPE, SELECTED_RANGE, TARGET_CONTENT } from '../../../constants/CSVDownloadConstant';
import { MSG_ADD_VIDEO_SAME_TIME, MSG_EXCEED_VIDEO_PLAY_TIME, W_REQUIRED } from '../../../constants/MessageTemplate';
import RenderField from '../../../utils/ReduxFormUtils';
import MessageValidate from '../../../components/MessageValidate';
import { SELECT_BOX_DATA } from '../../../constants/SelectBoxData';

class LearningHistoryCSVForm extends Component {
  render() {
    let contentTypeName = null;
    let groupSelectedNumber = 0;
    const {
      csvDownloadHandler,
      showSelectGroupDlg,
      learningHistoryCSVDownload,
      structures,
      isProgressStatusCSVDownloadContainer,
      targetContent,
      includingDormantUsers,
      selectedRange,
      contentType,
      targetCourse,
      targetCourseList,
      targetContentList,
      targetUserList,
      openExportDialog,
      dormantUserDataAcquisitionPermissionFlag,
      progressStatusType,
      targetBoxList,
    } = this.props;

    const { selectedGroup } = learningHistoryCSVDownload;
    const { bySecernId } = structures;
    const numberCourseList = Object.keys(targetCourseList).length;
    const numberContentList = Object.keys(targetContentList).length;
    const numberUserList = Object.keys(targetUserList).length;
    const numberBoxList = Object.keys(targetBoxList).length;

    if (contentType && contentType.length) {
      contentTypeName = contentType.join('/');
    }

    if (this.props.isShowGroupNumber) {
      groupSelectedNumber = selectedGroup.length;
    }

    const isContentProgressStatusType = progressStatusType === PROGRESS_STATUS_CSV_TYPE.CONTENT;
    const isBoxProgressStatusType = progressStatusType === PROGRESS_STATUS_CSV_TYPE.BOX;
    const isCourseProgressStatusType = progressStatusType === PROGRESS_STATUS_CSV_TYPE.COURSE;

    return (
      <div>
        {isProgressStatusCSVDownloadContainer === false ? (
          <h3 className="margin-left-20 margin-bottom-10">
            指定した検索項目に従い、学習履歴情報をCSVファイルにダウンロードします
          </h3>
        )
          : (
            <h3 className="margin-left-20 margin-bottom-10">
              指定した検索項目に従い、進捗状況情報をCSVファイルにダウンロードします
            </h3>
          )}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            openExportDialog();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="margin-left-20">
            { (isProgressStatusCSVDownloadContainer === false) && (
              <div>
                <Form.Group className="form-info">
                  <Col sm={3} as={Form.Label} >
                    対象期間
                  </Col>
                  <Col sm={3}>
                    <RenderField
                      type="datetime"
                      name="createdDateFrom"
                      validates={[VALIDATE_TYPE.DATE_TIME]}
                      normalizeDateTime
                    />
                  </Col>
                  <Col sm={1} className="text-center" as={Form.Label}>
                    ～
                  </Col>
                  <Col sm={3}>
                    <RenderField
                      type="datetime"
                      name="createdDateTo"
                      validates={[VALIDATE_TYPE.DATE_TIME]}
                      normalizeDateTime
                    />
                  </Col>
                </Form.Group>

                <Col sm={12}>
                  <RenderField
                    name="dateTimeMinMax"
                    type="dateTimeMinMax"
                    validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                    keyDateFrom={'createdDateFrom'}
                    keyDateTo={'createdDateTo'}
                  />
                </Col>
              </div>
            )}

            {/* Coverage */}

            {isProgressStatusCSVDownloadContainer && (
              <Form.Group className="form-info">
                <Col sm={12} className="padding-left-15 padding-bottom-7">
                  <Col sm={2}>
                    <RenderField
                      type="selectbox"
                      name="progressStatusType"
                      data={SELECT_BOX_DATA.PROGRESS_STATUS_CSV_TYPE}
                      handleChangeOption={this.props.changeProgressStatusTypeHandler}
                    />
                  </Col>
                </Col>
              </Form.Group>
            )}
            <Form.Group className="form-info">
              <Col sm={2} as={Form.Label}>
                対象ユーザー
              </Col>
              <Col sm={2} as={Form.Label}>
                <RenderField
                  type="radio"
                  name="selectedRange"
                  value={SELECTED_RANGE.ALL}
                  label="全体"
                  checkRadioChange
                  radioChange={this.props.changeSelectedRangeHandler}
                />
              </Col>
              {isContentProgressStatusType && (
                <Col sm={3} as={Form.Label}>
                  <RenderField
                    type="radio"
                    name="selectedRange"
                    value={SELECTED_RANGE.GROUP}
                    label="ユーザーグループ指定"
                    checkRadioChange
                    radioChange={this.props.changeSelectedRangeHandler}
                  />
                </Col>
              )}
              <Col sm={2} as={Form.Label}>
                <RenderField
                  type="radio"
                  name="selectedRange"
                  value={SELECTED_RANGE.USER}
                  label="ユーザー指定"
                  checkRadioChange
                  radioChange={this.props.changeSelectedRangeHandler}
                  className="margin-clear"
                />
              </Col>
              {selectedRange === SELECTED_RANGE.INDIVIDUAL ? (
                <Col sm={4}>
                  <Col sm={6}>
                    <Button variant="primary" className="btn-96" onClick={showSelectGroupDlg}>
                      グループ指定
                    </Button>
                  </Col>
                  <Col sm={6}>
                    <Button variant="primary" className="btn-96" onClick={this.props.showSelectTargetUsersDialog}>
                      ユーザー指定
                    </Button>
                  </Col>
                </Col>
              )
                : null}
            </Form.Group>
            {dormantUserDataAcquisitionPermissionFlag && isContentProgressStatusType && (
              <Form.Group className="form-info">
                <Col sm={12} className="form-label">
                  <Col sm={8}>
                    {selectedRange !== SELECTED_RANGE.USER ? (
                      <RenderField
                        name="includingDormantUsers"
                        className="padding-top-clear"
                        value={includingDormantUsers}
                        type="checkbox"
                        label="休止状態のユーザーも含む"
                      />
                    )
                      : null}
                  </Col>
                </Col>
              </Form.Group>
            )}
            {(selectedRange !== SELECTED_RANGE.ALL) && (
              <Form.Group className="form-info">
                <Col sm={12} className='padding-bottom-7'>
                  <Col sm={3} as={Form.Label}>
                    {(groupSelectedNumber > 0) || (numberUserList > 0) ? '対象件数' : null}
                  </Col>

                  <Col sm={6} as={Form.Label}>
                    {groupSelectedNumber > 0 ? `グループ　${groupSelectedNumber}件` : null}

                    {numberUserList > 0 ? `ユーザー　${numberUserList}件` : null}
                  </Col>
                  <Col sm={3}>
                    <Button variant="primary" className="btn-96" onClick={this.props.openSelectedRangeModal}>
                      選択
                    </Button>
                  </Col>
                </Col>
              </Form.Group>
            )}
            {!(groupSelectedNumber > 0) && !(numberUserList > 0) && (this.props.isShowTargetUserError) ? (
              <Col sm={12} as={Form.Label}>
                <MessageValidate
                  errorType={1}
                  visible={this.props.isShowTargetUserError}
                  errorMessage={messageTemplate(this.props.errorUserLabel, W_REQUIRED)}
                />
              </Col>
            )
              : null}
            {/* Target content */}

            <Form.Group className="form-info">
              {isCourseProgressStatusType && (
                <>
                  <Col sm={2} as={Form.Label} className="padding-top-bottom-7" >
                    対象コース
                  </Col>
                  <Col sm={2} as={Form.Label} className="padding-right-clear">
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.ALL}
                      label="全コース"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler}
                    />
                  </Col>
                  <Col sm={2} as={Form.Label} className="padding-right-clear">
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.COURSE}
                      label="コース指定"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler}
                    />
                  </Col>
                </>
              )}
              {isBoxProgressStatusType && (
                <>
                  <Col sm={2} as={Form.Label} className="padding-top-bottom-7" >
                    対象セクション
                  </Col>
                  <Col sm={2} as={Form.Label} className="padding-right-clear">
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.ALL}
                      label="全セクション"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler}
                    />
                  </Col>
                  <Col sm={2} as={Form.Label} className="padding-right-clear">
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.BOX}
                      label="セクション指定"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler}
                    />
                  </Col>
                </>
              )}
              {isContentProgressStatusType && (
                <>
                  <Col sm={2} as={Form.Label}>
                    対象コンテンツ
                  </Col>
                  <Col sm={2} as={Form.Label}>
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.ALL}
                      label="全コンテンツ"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler}
                    />
                  </Col>
                  <Col sm={2} as={Form.Label}>
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.COURSE}
                      label="コース指定"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler}
                    />
                  </Col>
                  <Col sm={3} as={Form.Label}>
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.CONTENT_TYPE}
                      label="コンテンツ種別指定"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler} />
                  </Col>
                  <Col sm={3} as={Form.Label}>
                    <RenderField
                      type="radio"
                      name="targetContent"
                      value={TARGET_CONTENT.CONTENT_SPECIFICATION}
                      label="コンテンツ指定"
                      checkRadioChange
                      radioChange={this.props.changeTargetContentHandler} />
                  </Col>
                </>
              )}
            </Form.Group>

            { (targetContent !== TARGET_CONTENT.ALL) && (
              <Form.Group className="form-info">
                <Col sm={12} className="margin-top-10">
                  <Col sm={3} as={Form.Label}>
                    {(numberCourseList > 0 || numberContentList > 0 || numberBoxList > 0) ? '対象件数' : null}
                    {contentType && contentType.length ? `コンテンツ種別` : null}
                  </Col>
                  <Col sm={6} as={Form.Label}>
                    {contentType && contentType.length ? `${contentTypeName}` : null}

                    {numberCourseList > 0 ? `コース　${numberCourseList}件` : null}

                    {numberContentList > 0 ? `コンテンツ　${numberContentList}件` : null}

                    {numberBoxList > 0 ? `セクション　${numberBoxList}件` : null}
                  </Col>

                  <Col sm={3}>
                    <Button variant="primary" className="btn-96" onClick={this.props.openTargetContentModal}>
                      選択
                    </Button>
                  </Col>
                </Col>
                {!(contentType && contentType.length) && !(numberCourseList > 0) &&
                  !(numberContentList > 0) ? (
                  <Col sm={12} style={{ marginBottom: '5px' }} as={Form.Label}>
                    <MessageValidate
                      errorType={1}
                      visible={this.props.isShowTargetContentError}
                      errorMessage={messageTemplate(this.props.errorContentLabel, W_REQUIRED)}
                    />
                  </Col>
                )
                  : null
                }
              </Form.Group>
            )}
            {isProgressStatusCSVDownloadContainer && (
              <Form.Group className="form-info">
                <Col sm={2} as={Form.Label}>
                  完了ステータス
                </Col>
                <Col sm={2} as={Form.Label}>
                  <RenderField
                    type="radio"
                    name="selectedCompletionType"
                    value={SELECTED_COMPLETION_TYPE.ALL}
                    label="全て"
                    checkRadioChange
                  />

                </Col>
                <Col sm={3} as={Form.Label}>
                  <RenderField
                    type="radio"
                    name="selectedCompletionType"
                    value={SELECTED_COMPLETION_TYPE.COMPLETE}
                    label="完了状態のみ"
                    checkRadioChange
                  />
                </Col>
                <Col sm={2} as={Form.Label}>
                  <RenderField
                    type="radio"
                    name="selectedCompletionType"
                    value={SELECTED_COMPLETION_TYPE.INCOMPLETE}
                    label="未完了状態のみ"
                    checkRadioChange
                    className="margin-clear"
                  />
                </Col>
              </Form.Group>
            )}

          </Col>

          <Form.Group className="text-center">
            <Col sm={12} className="margin-top-20 padding-left-right-clear">
              <Button variant="primary" className="btn-96" type="submit">
                CSV出力
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

function messageTemplate(label, msg) {
  return msg.replace('{0}', label);
}

const mapStateToProps = (state, ownProps) => {
  const { form } = state.form;
  const { learningHistoryCSVDownload, targetCourseList, targetContentList, targetUserList, targetBoxList } =
    state.csvDownload;
  const { structures } = state.container;
  return {
    form,
    learningHistoryCSVDownload,
    ...{ structures },
    targetCourseList,
    targetContentList,
    targetUserList,
    targetBoxList,
  };
};

export default connect(mapStateToProps)(LearningHistoryCSVForm);
